'use client';

import { Button, Text, Tooltip } from '@terra/ui-design-system';
import { VStack } from '@terra/ui-styled-system';
import type { PortalRegion } from '../../utils/portalRegions';
import {
  PORTAL_REGION_CARD_WIDTH,
  PortalRegionFlagIcon,
} from './PortalRegionFlagIcon';

type PortalRegionFlagButtonProps = {
  region: PortalRegion;
  isSelected: boolean;
  disabled?: boolean;
  regionLabel: string;
  flagAlt: string;
  onSelect: () => void;
};

export function PortalRegionFlagButton({
  region,
  isSelected,
  disabled,
  regionLabel,
  flagAlt,
  onSelect,
}: PortalRegionFlagButtonProps) {
  const regionLabelId = `portal-region-label-${region}`;

  return (
    <Tooltip title={regionLabel}>
      <Button
        variant={isSelected ? 'solid' : 'outline'}
        size="sm"
        disabled={disabled}
        aria-labelledby={regionLabelId}
        aria-pressed={isSelected}
        w={`${PORTAL_REGION_CARD_WIDTH}px`}
        minW={`${PORTAL_REGION_CARD_WIDTH}px`}
        maxW={`${PORTAL_REGION_CARD_WIDTH}px`}
        h="auto"
        px={2}
        py={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        onClick={onSelect}
      >
        <VStack gap={1.5} alignItems="center">
          <PortalRegionFlagIcon region={region} alt={flagAlt} />
          <Text
            id={regionLabelId}
            fontSize="xs"
            color={isSelected ? 'fg.default' : 'fg.muted'}
            fontWeight={isSelected ? 'medium' : 'normal'}
            lineHeight="tight"
            textAlign="center"
            w={`${PORTAL_REGION_CARD_WIDTH}px`}
            truncate
          >
            {regionLabel}
          </Text>
        </VStack>
      </Button>
    </Tooltip>
  );
}
